/**
 * Builds the full Accident Intake submit payload from page form state.
 * Keep field shapes aligned with each step form's `data` object.
 */
export function buildIntakePayload(formData = {}, options = {}) {
    return {
        aboutYou: {
            completionMethod: formData.aboutYou?.completionMethod ?? null,
            informationProvider: formData.aboutYou?.informationProvider ?? null,
            fullName: formData.aboutYou?.fullName ?? null,
            dateOfBirth: formData.aboutYou?.dateOfBirth ?? null,
            phone: formData.aboutYou?.phone ?? null,
            email: formData.aboutYou?.email ?? null,
        },
        whatHappened: {
            incidentType: formData.whatHappened?.incidentType ?? null,
            incidentDate: formData.whatHappened?.incidentDate ?? null,
            dateCertainty: formData.whatHappened?.dateCertainty ?? null,
            city: formData.whatHappened?.city ?? null,
            state: formData.whatHappened?.state ?? null,
            description: formData.whatHappened?.description ?? null,
            vehicleRole: formData.whatHappened?.vehicleRole ?? null,
            seatBelt: formData.whatHappened?.seatBelt ?? null,
            vehicleStruck: formData.whatHappened?.vehicleStruck ?? [],
            airbagsDeployed: formData.whatHappened?.airbagsDeployed ?? null,
            headStrike: formData.whatHappened?.headStrike ?? null,
            dazedOrConfused: formData.whatHappened?.dazedOrConfused ?? null,
        },
        howYouFelt: {
            immediateSymptoms: formData.howYouFelt?.immediateSymptoms ?? [],
            delayedSymptoms: formData.howYouFelt?.delayedSymptoms ?? [],
            emsCalled: formData.howYouFelt?.emsCalled ?? null,
            erEvaluated: formData.howYouFelt?.erEvaluated ?? null,
        },
        symptomsToday: {
            problems: formData.symptomsToday?.problems ?? [],
        },
        healthScreening: {
            bladderControlLoss: formData.healthScreening?.bladderControlLoss ?? null,
            bowelControlLoss: formData.healthScreening?.bowelControlLoss ?? null,
            groinNumbness: formData.healthScreening?.groinNumbness ?? null,
            worseningWeakness: formData.healthScreening?.worseningWeakness ?? null,
            difficultyWalking: formData.healthScreening?.difficultyWalking ?? null,
        },
        treatmentReceived: {
            treatments: formData.treatmentReceived?.treatments ?? [],
        },
        treatingProviders: {
            providers: formData.treatingProviders?.providers ?? [],
        },
        testsImaging: {
            tests: formData.testsImaging?.tests ?? [],
        },
        previousInjuries: {
            priorInjuries: formData.previousInjuries?.priorInjuries ?? [],
        },
        medicalSurgical: {
            medicalConditionsStatus: formData.medicalSurgical?.medicalConditionsStatus ?? null,
            surgeries: formData.medicalSurgical?.surgeries ?? [],
        },
        medicationsAllergies: {
            currentMedications: formData.medicationsAllergies?.currentMedications ?? null,
            allergies: formData.medicationsAllergies?.allergies ?? null,
        },
        workInformation: {
            employmentStatus: formData.workInformation?.employmentStatus ?? null,
        },
        socialFamily: {
            smoking: formData.socialFamily?.smoking ?? null,
            alcohol: formData.socialFamily?.alcohol ?? null,
            drugUse: formData.socialFamily?.drugUse ?? null,
            familyHistory: formData.socialFamily?.familyHistory ?? null,
        },
        dailyActivities: {
            ...(formData.dailyActivities || {}),
            assistiveDevices: formData.dailyActivities?.assistiveDevices ?? [],
        },
        healthQuestions: formData.healthQuestions ?? {},
        reviewSubmit: {
            chiefComplaint: formData.reviewSubmit?.chiefComplaint ?? null,
        },
        confirmSubmit: {
            signatureName: formData.confirmSubmit?.signatureName ?? null,
            confirmationAccepted: Boolean(formData.confirmSubmit?.confirmationAccepted),
        },
        meta: {
            submittedAt: new Date().toISOString(),
            source: options.authenticated ? 'patient-accident-intake' : 'accident-intake',
            version: 1,
            patientId: options.patientId ?? null,
        },
    }
}
